import React from "react";
import { LocationAnswerValue } from "consumerhouse-shared";
import { FormRow, RawFormLocation } from "../FormElements";
import { QuestionContainer, QuestionDefinition, QuestionProps } from "../QuestionAnswer";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons";

export const LocationQuestionDefinition: QuestionDefinition = {
    icon: faMapMarker,
    defaultOptions: {},
    questionComponent: LocationQuestion,
};

function LocationQuestion(props: QuestionProps<{}, LocationAnswerValue>) {
    return (
        <QuestionContainer>
            <FormRow>
                <RawFormLocation
                    requireStreet
                    defaultSelected={props.value?.address}
                    style={{ flexGrow: 1 }}
                    readOnly={props.readOnly}
                    onChange={(ev) => props.onChange({ address: ev })}
                />
            </FormRow>
        </QuestionContainer>
    );
}
